<div class="data-source-card">
  <div class="data-source-card-text">
    <span class="card-text-title" nz-typography>{{dataSource.supplier_system_partner_name}}</span>
    <span class="card-text-subtitle" nz-typography nzType="secondary">{{dataSource.supplier_system_partner_id }}</span>
  </div>
  <div class="data-source-card-logo">
    <div class="logo-wrapper" (click)="onLogoClick()">
      <img [src]="previewUrl || dataSource.logo_url || 'assets/placeholder-image.png'" alt="Logo"/>
      <div class="logo-overlay" *ngIf="isDownloadImagePossible">
        <span nz-icon nzType="edit" nzTheme="outline" class="edit-icon"></span>
      </div>
    </div>
    <input
      *ngIf="isDownloadImagePossible"
      type="file"
      accept="image/png"
      #fileInput
      (change)="onFileSelected($event)"
      style="display: none;"
    />
  </div>
<!--  <div class="data-source-info" *ngIf="customerPK">-->
<!--    <div class="data-source-info-item">-->
<!--      <span>Credentials Ok?</span>-->
<!--      <ng-container [ngSwitch]="(dataSource.id| verificationStatus : customerPK | async)">-->
<!--                      <span *ngSwitchCase="'unverified'" nz-tooltip [nzTooltipTitle]="'Verification in progress'" nz-typography nzType="secondary">-->
<!--                        <span nz-icon nzType="info-circle" nzTheme="outline"></span>-->
<!--                      </span>-->
<!--        <span *ngSwitchCase="'failed'" nz-tooltip [nzTooltipTitle]="'Verification failed'" nz-typography nzType="danger">-->
<!--                        <span nz-icon nzType="warning" nzTheme="outline"></span>-->
<!--                      </span>-->
<!--        <span *ngSwitchCase="'verified'" nz-tooltip [nzTooltipTitle]="'Verification successful'" nz-typography nzType="success">-->
<!--                        <span nz-icon nzType="check-circle" nzTheme="outline"></span>-->
<!--                      </span>-->
<!--      </ng-container>-->
<!--    </div>-->
<!--    <div class="data-source-info-item">-->
<!--      <span style="font-size: 16px; font-weight: 500">Enabled:</span>-->
<!--      <nz-switch [nzDisabled]="dataSource.enabled"></nz-switch>-->
<!--    </div>-->
<!--  </div>-->
  <div class="data-source-card-footer-actions" *ngIf="isFooterVisible">
    <button nz-button nzType="default" nzSize="large">
      <span nz-icon nzType="delete" nzTheme="outline" (click)="deleteDataSourceRequest()"></span>
      Delete
    </button>
    <button nz-button nzType="default" nzSize="large">
      Configure
    </button>
  </div>
</div>
